export const SET_MODEL = 'SET_MODEL';
export const SET_QUESTIONS = 'SET_QUESTIONS';
export const SET_QUERY_PAYLOAD = 'SET_QUERY_PAYLOAD;';
export const SET_IMAGES = 'SET_IMAGES';
export const SET_PRICING = 'SET_PRICING';
export const SET_BOM_ITEMS = 'SET_BOM_ITEMS';
export const SET_VARIABLES = 'SET_VARIABLES';
export const SET_LANG = 'SET_LANG'; // The language that was selected when the query was initiated
export const SET_IS_USING_SELLER_SYSTEM_DISCOUNTS =
  'SET_IS_USING_SELLER_SYSTEM_DISCOUNTS';
export const SET_CUSTOM_NET_PRICE = 'SET_CUSTOM_NET_PRICE';

export const QUERY_ATTEMPT = 'QUERY_ATTEMPT';
export const QUERY_SUCCESS = 'QUERY_SUCCESS';
export const QUERY_ERROR = 'QUERY_ERROR';
export const QUERY_RESET = 'QUERY_RESET';

export const RESET_CONFIGURE_FORM = 'RESET_CONFIGURE_FORM';

export const SET_MODELS = 'SET_MODELS';

// Form
export const SET_IS_FORM_VALID = 'SET_IS_FORM_VALID';
export const SET_ARE_ALL_FIELDS_TOUCHED = 'SET_ARE_ALL_FIELDS_TOUCHED';
export const SET_TOUCHED_QUESTION_NAME = 'SET_TOUCHED_QUESTION_NAME';
export const SET_MANUALLY_CHANGED_QUESTION_NAMES =
  'SET_MANUALLY_CHANGED_QUESTION_NAMES';
export const RESET_MANUALLY_CHANGED_QUESTION_NAMES =
  'RESET_MANUALLY_CHANGED_QUESTION_NAMES';
export const SET_MANUALLY_CLEARED_QUESTION_NAMES =
  'SET_MANUALLY_CLEARED_QUESTION_NAMES';
export const RESET_MANUALLY_CLEARED_QUESTION_NAMES =
  'RESET_MANUALLY_CLEARED_QUESTION_NAMES';
export const RESET_TOUCHED_QUESTION_NAMES = 'RESET_TOUCHED_QUESTION_NAMES';
export const SET_MODEL_NOT_FOUND = 'SET_MODEL_NOT_FOUND';
export const SET_TRIGGER_QUERY_REQUEST_AFTER_FORM_RESET =
  'SET_TRIGGER_QUERY_REQUEST_AFTER_FORM_RESET';
export const SET_INCLUDE_BOM_ITEMS = 'SET_INCLUDE_BOM_ITEMS';
export const SET_RESET_DISCOUNT_LINES = 'SET_RESET_DISCOUNT_LINES';
export const SET_PREDEFINED_PRICING = 'SET_PREDEFINED_PRICING';

// Quotation -> order
export const SET_QUOTATION_ORDER_ACTIVE_TAB = 'SET_QUOTATION_ORDER_ACTIVE_TAB';
export const SET_SELECTED_QUOTATION_LINE_IDS =
  'SET_SELECTED_QUOTATION_LINE_IDS';
export const SET_QUOTATION_ORDER_SUPPLIER_DETAILS =
  'SET_QUOTATION_ORDER_SUPPLIER_DETAILS';
export const SYNC_QUOTATION_ORDER_SUPPLIERS = 'SYNC_QUOTATION_ORDER_SUPPLIERS';
export const RESET_QUOTATION_ORDER = 'RESET_QUOTATION_ORDER';

// Common
export const SET_EDIT_CONFIGURATION_VALIDATION_WARNINGS =
  'SET_EDIT_CONFIGURATION_VALIDATION_WARNINGS';
export const RESET_EDIT_CONFIGURATION_VALIDATION_WARNINGS =
  'RESET_EDIT_CONFIGURATION_VALIDATION_WARNINGS';
export const SET_IS_DARK_MODE = 'SET_IS_DARK_MODE';
export const SET_APP_MODE = 'SET_APP_MODE';
export const SET_QUERY_PARAMS_PROCESSED = 'SET_QUERY_PARAMS_PROCESSED'; // Delay private/public route redirects until query params have been processed
export const SET_IS_MOBILE_APP = 'SET_IS_MOBILE_APP';
export const SET_IS_LOADING_SCREEN_SHOWN = 'SET_IS_LOADING_SCREEN_SHOWN';
export const SET_IS_EXTERNAL_HOST = 'SET_IS_EXTERNAL_HOST';

// Shopping cart
export const TRIGGER_ADD_TO_SHOPPING_CART = 'TRIGGER_ADD_TO_SHOPPING_CART';
export const SET_TRIGGER_SHOW_ADDED_TO_CART_MODAL =
  'SET_TRIGGER_SHOW_ADDED_TO_CART_MODAL';
export const SET_CURRENTLY_EDITING_SHOPPING_CART_LINE_DATA =
  'SET_CURRENTLY_EDITING_SHOPPING_CART_LINE_DATA';
export const SET_TRIGGER_SHOW_CART_ITEM_EDITED_MODAL =
  'SET_TRIGGER_SHOW_CART_ITEM_EDITED_MODAL';
export const TRIGGER_EDIT_CART_ITEM = 'TRIGGER_EDIT_CART_ITEM';
export const TRIGGER_UPDATE_QUOTATION_LINE = 'TRIGGER_UPDATE_QUOTATION_LINE';
export const SET_MAX_CONN_LEAD_TIME = 'SET_MAX_CONN_LEAD_TIME';
export const SET_SHOPPING_CART_ID = 'SET_SHOPPING_CART_ID';
export const SET_QUOTATION_CART_ID = 'SET_QUOTATION_CART_ID';
export const SET_CART_LENGTH = 'SET_CART_LENGTH';
export const SET_CURRENCY = 'SET_CURRENCY';
export const SET_ADDITIONAL_CART_DETAILS = 'SET_ADDITIONAL_CART_DETAILS';
export const RESET_SHOPPING_CART = 'RESET_SHOPPING_CART';

// Submit configuration
export const TRIGGER_SUBMIT_CONFIGURATION = 'TRIGGER_SUBMIT_CONFIGURATION';
export const SET_INTENT_UUID = 'SET_INTENT_UUID';
export const GET_EDIT_CONFIGURATION_ATTEMPT = 'GET_EDIT_CONFIGURATION_ATTEMPT';
export const GET_EDIT_CONFIGURATION_SUCCESS = ' GET_EDIT_CONFIGURATION_SUCCESS';
export const GET_EDIT_CONFIGURATION_ERROR = 'GET_EDIT_CONFIGURATION_ERROR';
export const GET_EDIT_CONFIGURATION_RESET = 'GET_EDIT_CONFIGURATION_RESET';
export const SET_TEST_COMPANY_MODEL_CONFIGURATION =
  'SET_TEST_COMPANY_MODEL_CONFIGURATION';
export const SET_BASE64_METADATA = 'SET_BASE64_METADATA';
export const SET_IS_TEST_CONFIGURATION_MODAL_OPEN =
  'SET_IS_TEST_CONFIGURATION_MODAL_OPEN';
export const SET_EXTRA_PRICE_QUESTIONS = 'SET_EXTRA_PRICE_QUESTIONS';
export const SET_SELECTED_CONFIGURATION_ANSWERS =
  'SET_SELECTED_CONFIGURATION_ANSWERS';
export const SET_CLEARED_EXTRA_PRICE_QUESTION_SLUGS =
  'SET_CLEARED_EXTRA_PRICE_QUESTION_SLUGS';
export const SET_TRIGGER_SHOW_SUBMIT_CONFIRMED_MODAL =
  'SET_TRIGGER_SHOW_SUBMIT_CONFIRMED_MODAL';
export const SET_SUBMISSION_IS_SLOW = 'SET_SUBMISSION_IS_SLOW';
export const SET_SUBMISSION_BEING_CHECKED = 'SET_SUBMISSION_BEING_CHECKED';
export const SET_FIXED_AMOUNT_CURRENCY = 'SET_FIXED_AMOUNT_CURRENCY';
export const SET_INDICATIVE_QUESTION_KEYS = 'SET_INDICATIVE_QUESTION_KEYS';
export const TRIGGER_SAVE_TEMPLATE = 'TRIGGER_SAVE_TEMPLATE';
export const SET_TEMPLATE_TO_APPLY = 'SET_TEMPLATE_TO_APPLY';
export const SET_SELECTED_TEMPLATE = 'SET_SELECTED_TEMPLATE';

// User
export const SET_IS_LOGGED_IN = 'SET_IS_LOGGED_IN';
export const SET_USER_INFO = 'SET_USER_INFO';
export const SET_COMPANY = 'SET_COMPANY';
export const LOGOUT = 'LOGOUT';
export const COMPANY_CHANGED = 'COMPANY_CHANGED';
export const SET_UPDATED_USER_INFO = 'SET_UPDATED_USER_INFO';
export const SET_INTENT = 'SET_INTENT';

// Order
export const SET_ACTIVE_TAB = 'SET_ACTIVE_TAB';
export const RESET_ORDER = 'RESET_ORDER';
export const SET_COMPANY_ID = 'SET_COMPANY_ID';
export const SET_PRODUCT_ID = 'SET_PRODUCT_ID';
export const SET_ORDER_PRODUCTS_STEP = 'SET_ORDER_PRODUCTS_STEP';
export const SET_DETAILS_ORDER_DATA = 'SET_DETAILS_ORDER_DATA';
export const SET_DETAILS_QUOTATION_DATA = 'SET_DETAILS_QUOTATION_DATA';
